import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

type TabsProps = {
  variant: 'default' | 'contained'
}

const wrapVariants = {
  contained: css`
    margin: 0;
    background-color: ${theme.colors.ion.primary.softer};
    border-radius: ${theme.shapes.borderRadius.md};
    padding: ${theme.spacing.xs};
    gap: ${theme.spacing.xs};
  `,
  default: css`
    border-bottom: ${theme.shapes.borderWidth.thin} ${theme.colors.neutral.clear};
  `,
}

export const ActionTabsWrap = styled.div<TabsProps>`
  display: flex;
  padding: 0 ${theme.spacing['2xm']};
  margin-bottom: ${theme.spacing['2xm']};

  overflow-x: auto;
  ::-webkit-scrollbar-thumb {
    border: 6px solid ${theme.colors.neutral.white};
  }

  ${({ variant }) => wrapVariants[variant]}
`

const itemVariants = {
  contained: css`
    height: 36px;
    font-family: ${theme.typography.family.primary};
    font-weight: ${theme.typography.weight.sm};
    padding: 0 ${theme.spacing.md};
    background-color: ${theme.colors.ion.state.enabled.soft};
    border-radius: ${theme.shapes.borderRadius.sm};
    color: ${theme.colors.ion.state.focus.onsoft};

    &:hover {
      background-color: ${theme.colors.ion.info.soft};
    }

    &.active {
      background-color: ${theme.colors.ion.state.focus.soft};
    }
  `,
  default: css`
    font-family: ${theme.typography.family.bold};
    font-weight: ${theme.typography.weight.lg};
    padding: ${theme.spacing.xs};
    border-bottom: ${theme.shapes.borderWidth.md} transparent;

    &:hover {
      background-color: ${theme.colors.neutral.clear};
    }

    &.active {
      border-bottom-color: ${theme.colors.primary.main};
      color: ${theme.colors.primary.main};
    }
  `,
}

export const ActionTabsItem = styled.button<TabsProps>`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  color: ${theme.colors.neutral.light};

  background-color: transparent;
  border: 0;
  font-size: ${theme.typography.sizes.xs};
  padding: ${theme.spacing.md};

  white-space: nowrap;
  transition: all 0.5s;

  :disabled {
    pointer-events: none;
    color: ${theme.colors.neutral.lighthover};
  }

  ${({ variant }) => itemVariants[variant]}
`
